import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataLayer } from "../trackingHelper";

export function sendShareCartTracking(listid: string, state: ApplicationState, cart?: Readonly<Cart>) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    const dataLayerProducts: any[] = [];
    cart?.cartLines?.forEach(cartLine => {
        dataLayerProducts.push({
            name: cartLine.shortDescription,
            id: cartLine.erpNumber,
            price: cartLine?.pricing?.actualPrice,
            quantity: cartLine.qtyOrdered,
            brand: cartLine?.properties?.cartLineBrandName,
            category: cartLine?.properties?.cartlineCategoryName,
            list: cartLine?.properties?.productSourceActionField || "",
            position: cartLine?.properties?.productListPosition || "",
        });
    });
    const shareCartEvent = {
        event: "shareCart",
        ecommerce: {
            currencyCode: state.context.session.currency?.currencyCode,
            add: {
                actionField:
                {
                    id: listid,
                    list: "Shared Cart",
                    action: "send",
                },
                products: dataLayerProducts,
            },
        },
    };
    dataLayer.push({ ecommerce: null });
    dataLayer.push(shareCartEvent);
}

export default sendShareCartTracking;